import { useMemo, useState } from 'react'
import useScrollTop from '~/hooks/useScrollTop'
import { MyIcon } from '../ui/MyIcon'
import { useRouter } from 'next/router'
import { Popover } from 'antd'
import { QRCodeCanvas } from 'qrcode.react'

import styles from './RightBar.module.css'
import classNames from 'classnames'
import SubmitFormModal from './SubmitFormModal'
import { IconCooperation } from 'wujieai-react-icon'

const hideBusinessReg =
  /^(\/note\/|\/plaza\/|\/collection\/|\/collection\/private\/|\/comic\/)(\[id\]|[\d]+)/

const hideScrollTopReg = /^(\/comic\/)(\[id\]|[\d]+)/
type Props = {
  dark?: boolean
}
export const RightBar = ({ dark = true }: Props) => {
  const router = useRouter()
  const [visible, setVisible] = useState(false)

  const scrollTop = useScrollTop()
  const showScrollTop = useMemo(
    () => scrollTop > 1000 && !hideScrollTopReg.test(router.pathname),
    [scrollTop, router.pathname]
  )
  const hideBusiness = useMemo(
    () => hideBusinessReg.test(router.pathname),
    [router.pathname]
  )

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <div className="fixed bottom-3 right-3 z-50">
      {showScrollTop && (
        <div
          onClick={handleScrollTop}
          className={classNames(
            dark
              ? 'border-neutral-200 border bg-neutral-50/80'
              : 'border-neutral-700 border bg-neutral-900',
            'flex items-center justify-center w-10 h-10 rounded-[32px] border-solid  border  cursor-pointer mb-2'
          )}
        >
          <MyIcon
            icon="fanhuidingbu"
            className="text-neutral-500 text-[24px]"
          />
        </div>
      )}

      {!hideBusiness && (
        <div
          className={classNames(
            dark
              ? 'border-neutral-200 border bg-neutral-50/80'
              : 'border-neutral-700 border bg-neutral-900',
            'flex items-center justify-center flex-wrap w-10 py-2 rounded-[32px] border-solid  cursor-pointer'
          )}
        >
          {/* 联系我们 */}
          <Popover
            overlayClassName={classNames(styles.popover, !dark && 'light')}
            content={
              <div className="rounded-2xl text-center p-4">
                <div className="w-[128px] h-[128px] bg-white p-1">
                  <QRCodeCanvas
                    value={'https://u.wechat.com/EBkp4VBTAV6_IBIsxUdPaLQ'}
                    size={120}
                  ></QRCodeCanvas>
                </div>

                <div className="text-neutral-500 mt-4 leading-none">
                  无界AI小助手
                </div>
              </div>
            }
            placement="leftBottom"
            trigger={'hover'}
            zIndex={999}
          >
            <div className="relative">
              <MyIcon
                icon="connect-filled"
                className="text-[24px] text-neutral-500 block mb-1"
              />
            </div>
            <div className="text-[12px] text-neutral-500 leading-4 mb-2">
              联系
              <br />
              我们
            </div>
          </Popover>
          {/* 商务咨询 */}
          <div onClick={() => setVisible(true)}>
            <div className="relative">
              <IconCooperation className="text-[24px] text-neutral-500 block mb-1" />
            </div>
            <div className="text-[12px] text-neutral-500 leading-4 mb-2">
              商务
              <br />
              咨询
            </div>
          </div>
          {/* 下载 */}
          <Popover
            overlayClassName={classNames(styles.popover, !dark && 'light')}
            content={
              <div className="rounded-2xl text-center p-4">
                <div className="w-[128px] h-[128px] bg-white p-1">
                  <QRCodeCanvas
                    value={'https://m.wujieai.com/download'}
                    size={120}
                  ></QRCodeCanvas>
                </div>

                <div className="text-neutral-500 mt-4 leading-none">
                  Android & iPhone
                </div>
              </div>
            }
            placement="leftBottom"
            trigger={'hover'}
            zIndex={999}
          >
            <div className="relative">
              <MyIcon
                icon="mobile"
                className="text-[24px] text-neutral-500 block mb-1"
              />
            </div>
            <div className="text-[12px] text-neutral-500 leading-4">
              APP
              <br />
              下载
            </div>
          </Popover>
        </div>
      )}
      {visible && <SubmitFormModal visible={visible} setVisible={setVisible} />}
    </div>
  )
}
